const styles = {
  container: {
    padding: '30px',
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    fontFamily: 'Segoe UI, sans-serif',
    transition: 'margin-left 0.3s ease',
  },
  header: {
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '1.5rem',
  },
  hr: {
    width: '80px',
    border: '2px solid #1B019B',
    opacity: '1',
    margin: '10px auto',
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  cardStats: {
    padding: '20px',
    paddingBottom: '30px',
    borderRadius: '12px',
    background: 'white',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    position: 'relative',
    minHeight: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#333',
  },
  cardStatsPenalite: {
    border: '2px solid #dc3545',
    backgroundColor: '#f8d7da',
    color: '#dc3545',
  },
  detailsButton: {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    backgroundColor: '#1B019B',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    padding: '3px 8px',
    fontSize: '0.7rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '30px',
    gap: '15px'
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  filterIcon: {
    color: '#1B019B'
  },
  searchBar: {
    borderRadius: '20px',
    padding: '8px 12px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '250px'
  },
  select: {
    borderRadius: '20px',
    padding: '7px 12px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '180px'
  },
  dateInput: {
    borderRadius: '20px',
    padding: '7px 12px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '150px'
  },
  pageSizeLabel: {
    color: '#1B019B', 
    fontWeight: 500,
    marginRight: '5px'
  },
  exportButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    borderRadius: '30px',
    padding: '8px 20px',
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: '160px',
    fontSize: '1rem'
  },
  tableHeader: {
    backgroundColor: '#1B019B', 
    color: '#fff'
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center'
  },
  validateButton: {
    backgroundColor: '#198754',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '5px 10px',
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  cancelButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '5px 10px',
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  paginationButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    border: 'none',
    margin: '0 2px',
    borderRadius: '5px',
    padding: '5px 10px',
  },
  paginationActive: {
    backgroundColor: '#0d0066',
    color: 'white',
  },
  paginationDisabled: {
    backgroundColor: '#e0e0e0',
    color: '#a0a0a0',
    cursor: 'not-allowed',
  },
  primesLink: {
    borderRadius: '30px', 
    padding: '10px 25px', 
    color: 'white', 
    backgroundColor: '#1B019B', 
    textDecoration: 'none',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1050
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: '20px',
    width: '60%',
    maxWidth: '800px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '1px solid #eee'
  },
  closeButton: {
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#666'
  }
};

export default styles;